'use strict';

import * as moment from 'moment';

function OPDoneDialogController($scope, $mdDialog, completedAt, onComplete) {
  'ngInject';

  //console.log('>>>> candidate passed' + candidate);
  $scope.completedAt = moment(new Date());
  $scope.labelCompletedAt = $scope.completedAt.format('LLLL');
  $scope.onComplete = onComplete;

  $scope.save = function() {
    $mdDialog.hide({
      comments: $scope.comments,
      completedAt: $scope.completedAt.toDate()
    });
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}

export default OPDoneDialogController;
